import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "@/dev";
import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useStore } from '@/models';
import MenuIcon from '@/components/icons/MenuIcon';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import CopyAssetUid from '@/components/icons/CopyAssetUid';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import SignButton from '../signButton';
import MenuItem from './MenuItem';
import { useMenuList, useProfileList, useMoreList, useSettingList, useDownloadApp } from '@/hooks/header';
import cs from './index.module.scss';
import HeaderMenuBackIcon from '@/components/icons/HeaderMenuBackIcon';
import HeaderMenuArrowIcon from '@/components/icons/HeaderMenuArrowIcon';
import HeaderMenuUserIcon from '@/components/icons/HeaderMenuUserIcon';
import meunUserImg from '@/assets/img/header/meunUser.png';

const Menu = () => {
  const [visible, setVisible] = useState(false);
  const { account, ui } = useStore();
  const { isLogin, userInfo } = account;
  const { theme } = ui;
  const { push } = useHistory();
  const { t } = useTranslation();

  const { id, username } = userInfo;
  const menuList = useMenuList();
  const profileList = useProfileList();
  const moreList = useMoreList();
  const setting = useSettingList();
  const downloadApp = useDownloadApp();

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  // const menuData = useMemo(() => [menuList, profileList, moreList, downloadApp, setting], [
  //   menuList,
  //   profileList,
  //   moreList,
  //   setting,
  //   downloadApp,
  // ]);
  const copyInfo = (info, e) => {
    e.stopPropagation();
    copy(info);
    message.success(t('success.copy'));
  };
  const menuData = useMemo(() => [menuList], [menuList]);
  const renderMenuItem = useMemo(
    () =>
      menuData.map((wrap, i) => (
        <div key={i}>
          {/* <div className={cs.divider} /> */}
          {wrap.map((item, index) => (
            <MenuItem {...item} key={index} />
          ))}
        </div>
      )),
    [menuData],
  );

  return (
    <>
      <MenuIcon
        className={cs.icon}
        onClick={showDrawer}
        style={{ color: theme === 'Dark' ? 'white' : 'black', fontSize: '20px' }}
      />
      {ReactDOM.createPortal(
        <div className={cx(cs.drawer, { [cs.hidden]: !visible })} onClick={onClose}>
          <div
            className={cs.memuWrap}
            style={{
              transform: visible ? 'translateX(0)' : 'translateX(100%)',
            }}
          >
            <HeaderMenuBackIcon
              style={{
                paddingLeft: '2px',
              }}
            />

            <div className={cs.noLoginBox}>
              <HeaderMenuUserIcon className={cs.meunUserImg} onClick={onClose} />

              {isLogin ? (
                <>
                  {/* onClick={() => push('/account/profile/basic')} */}
                  <span className={cs.toReg}>{username}</span>
                  <span className={cs.welcome}>
                    UID: {id}
                    <CopyAssetUid
                      style={{ marginLeft: '9px' }}
                      onClick={e => {
                        copyInfo(id, e);
                      }}
                    />
                  </span>
                </>
              ) : (
                <>
                  <span className={cs.toReg} onClick={() => push('/register')}>
                    {t('header.sign')}
                    <HeaderMenuArrowIcon className="ml5" />
                  </span>
                  <span className={cs.welcome}>{t('header.welcome')}</span>
                </>
              )}
            </div>

            {renderMenuItem}
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default observer(Menu);
